var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FEC907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84056 12.834C7.18819 12.834 7.47056 13.1096 7.47056 13.4483C7.47056 13.7874 7.18819 14.0625 6.84056 14.0625H6.02325C5.84325 14.0625 5.67 13.9928 5.54288 13.8684C5.48005 13.8076 5.43006 13.7348 5.39586 13.6543C5.36166 13.5738 5.34394 13.4873 5.34375 13.3999V4.58381C5.34375 4.41225 5.4135 4.248 5.53781 4.1265C5.66156 4.00556 5.83031 3.9375 6.00638 3.9375H6.88219C7.22981 3.9375 7.51219 4.21256 7.51219 4.55175C7.51219 4.71487 7.44525 4.87069 7.32713 4.986C7.209 5.10075 7.04869 5.166 6.88219 5.166H6.68813V12.834H6.84056ZM13.6862 6.39225C14.1244 7.14488 14.3438 7.98694 14.3438 8.91844C14.3438 9.84994 14.1216 10.692 13.6789 11.4452C13.2362 12.1984 12.744 12.7755 11.9357 13.2981C11.1932 13.7784 10.4181 14.0619 9.45675 14.0619H9.13781C8.79019 14.0619 8.50781 13.7869 8.50781 13.4477C8.50781 13.1085 8.79019 12.834 9.13781 12.834H9.52594C10.2066 12.834 10.701 12.5522 11.2562 12.2321C11.8108 11.9126 12.1663 11.3889 12.4881 10.8242C12.8104 10.26 12.9718 9.62944 12.9718 8.93306C12.9713 8.22712 12.8081 7.59206 12.4813 7.02731C12.1631 6.47108 11.7016 6.01034 11.1448 5.69306C10.5801 5.3685 9.95231 5.20594 9.26212 5.20594H9.09506C8.74744 5.20594 8.46506 4.93144 8.46506 4.59225C8.46506 4.42912 8.532 4.27275 8.65013 4.158C8.76825 4.04269 8.928 3.978 9.09506 3.978H9.29137C10.2431 3.978 11.1037 4.19175 11.8733 4.62037C12.6282 5.03409 13.2553 5.64695 13.6862 6.39225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDew);
export default __webpack_public_path__ + "static/media/dew.a9fd1980dd871d17499cad94c5a42b7b.svg";
export { ForwardRef as ReactComponent };